/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDiagnosticHistoryItemResponseDto
 */
export interface AssetDiagnosticHistoryItemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    status: AssetDiagnosticHistoryItemResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    ocppStatus?: AssetDiagnosticHistoryItemResponseDtoOcppStatusEnum | null;
    /**
     * 
     * @type {object}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    ocppFileName?: object | null;
    /**
     * True when status is UPLOADED and uploadFileId is set (S3 object may still be missing after retention).
     * @type {boolean}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    downloadable: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticHistoryItemResponseDto
     */
    requestedAt: string;
}


/**
 * @export
 */
export const AssetDiagnosticHistoryItemResponseDtoStatusEnum = {
    Requested: 'REQUESTED',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Uploading: 'UPLOADING',
    Uploaded: 'UPLOADED',
    UploadFailed: 'UPLOAD_FAILED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED'
} as const;
export type AssetDiagnosticHistoryItemResponseDtoStatusEnum = typeof AssetDiagnosticHistoryItemResponseDtoStatusEnum[keyof typeof AssetDiagnosticHistoryItemResponseDtoStatusEnum];

/**
 * @export
 */
export const AssetDiagnosticHistoryItemResponseDtoOcppStatusEnum = {
    Idle: 'Idle',
    Uploading: 'Uploading',
    Uploaded: 'Uploaded',
    UploadFailed: 'UploadFailed'
} as const;
export type AssetDiagnosticHistoryItemResponseDtoOcppStatusEnum = typeof AssetDiagnosticHistoryItemResponseDtoOcppStatusEnum[keyof typeof AssetDiagnosticHistoryItemResponseDtoOcppStatusEnum];


/**
 * Check if a given object implements the AssetDiagnosticHistoryItemResponseDto interface.
 */
export function instanceOfAssetDiagnosticHistoryItemResponseDto(value: object): value is AssetDiagnosticHistoryItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('downloadable' in value) || value['downloadable'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    return true;
}

export function AssetDiagnosticHistoryItemResponseDtoFromJSON(json: any): AssetDiagnosticHistoryItemResponseDto {
    return AssetDiagnosticHistoryItemResponseDtoFromJSONTyped(json, false);
}

export function AssetDiagnosticHistoryItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDiagnosticHistoryItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'ocppStatus': json['ocppStatus'] == null ? undefined : json['ocppStatus'],
        'ocppFileName': json['ocppFileName'] == null ? undefined : json['ocppFileName'],
        'downloadable': json['downloadable'],
        'requestedAt': json['requestedAt'],
    };
}

export function AssetDiagnosticHistoryItemResponseDtoToJSON(json: any): AssetDiagnosticHistoryItemResponseDto {
    return AssetDiagnosticHistoryItemResponseDtoToJSONTyped(json, false);
}

export function AssetDiagnosticHistoryItemResponseDtoToJSONTyped(value?: AssetDiagnosticHistoryItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'ocppStatus': value['ocppStatus'],
        'ocppFileName': value['ocppFileName'],
        'downloadable': value['downloadable'],
        'requestedAt': value['requestedAt'],
    };
}

